import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import fr from './locales/fr.json';
import nl from './locales/nl.json';

function loadLocaleMessages() {
  const locales = { fr, nl, en };
  const messages = {};
  Object.keys(locales).forEach(key => {
    messages[key] = locales[key];
  });
  return messages;
}

const supportedLocales = ['fr', 'nl', 'en'];

function getInitialLocale() {
  if (typeof window === 'undefined') return 'fr';
  try {
    const savedLocale = window.localStorage.getItem('singing-locale');
    return supportedLocales.includes(savedLocale) ? savedLocale : 'fr';
  } catch {
    return 'fr';
  }
}

export default createI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'fr',
  legacy: false,
  messages: loadLocaleMessages(),
});
